import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

interface WBSCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  alternate?: boolean;
}

export function WBSCheckbox({
  checked,
  onChange,
  alternate,
  id,
  name,
  ...props
}: WBSCheckboxProps) {
  return (
    <CheckboxWrapper>
      <Checkbox
        $alternate={alternate}
        checked={checked}
        onChange={onChange}
        id={id}
        name={name}
        {...props}
      />
      {checked && <CheckIcon icon={faCheck} />}
    </CheckboxWrapper>
  );
}

const CheckboxWrapper = styled.div`
  display: inline-block;
  position: relative;
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })<{
  $alternate?: boolean;
}>`
  appearance: none;
  background: var(--grey-50);
  border-radius: 4px;
  box-shadow: var(--shadow-inset-md);
  cursor: pointer;
  display: grid;
  height: 20px;
  place-content: center;
  position: relative;
  transition: all 0.2s ease;
  width: 20px;

  &:checked {
    background: var(--wbs-red);
    ${({ $alternate }) =>
      $alternate
        ? 'box-shadow: var(--shadow-inset-lg); border: none;'
        : 'border: 2px solid var(--wbs-red); box-shadow: 1px 1px 1px var(--shadow-dark);'}
  }

  &:hover {
    border-color: var(--wbs-red);
  }
`;

export const CheckIcon = styled(FontAwesomeIcon)`
  color: var(--white);
  font-size: 11px;
  left: 50%;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const CheckboxLabel = styled.label`
  align-items: center;
  color: var(--black);
  cursor: pointer;
  display: flex;
  font-size: 13px;
  gap: 0.5rem;
`;
